import request from '../../utils/request'

const pre="/system/sysUsers";

export const reqLogin = (data) => {
    return request({
        url: pre+'/login',
        method: 'POST',
        data: data
    })
}
// 超级管理员切换当前操作租户
export const reqSwitchTenant = (params) => {
    return request({
        url: pre+'/switchTenant',
        method: 'POST',
        params
    })
}
export const reqGetInfo = (params) => {
    return request({
        url: pre+'/info',
        method: 'get',
        params
    })
}

export const reqListSysUsers = (data) => {
    return request({
        url: pre+'/page',
        method: 'POST',
        data: data
    })
}
export const reqInsertSysUsers = (data) => {
    return request({
        url: pre+'/insert',
        method: 'POST',
        data: data
    })
}
export const reqUpdateSysUsers = (data) => {
    return request({
        url: pre+'/update',
        method: 'POST',
        data: data
    })
}
export const reqDeleteSysUsers = (params) => {
    return request({
        url: pre+'/delete',
        method: 'get',
        params
    })
}
export const reqGetSysUsersById = (params) => {
    return request({
        url: pre+'/detail',
        method: 'get',
        params
    })
}
export const reqUpdatePwd = (data) => {
    return request({
        url: pre+'/updatePwd',
        method: 'post',
        data
    })
}

/**
 * 查询课时不足预警学生列表
 * @param {Object} params { threshold: 5, currentPage: 1, pageSize: 10 }
 */
export const reqLowClassHours = (params) => {
    return request({
        url: pre+'/lowClassHours',
        method: 'get',
        params
    })
}

export const reqUpdateUserType = (params) => {
    return request({
        url: pre+'/updateType',
        method: 'POST',
        params
    })
}

export const reqRechargePaperCount = (params) => {
    return request({
        url: pre+'/rechargePaperCount',
        method: 'POST',
        params
    })
}

export const reqRechargeClassHours = (params) => {
    return request({
        url: pre+'/rechargeClassHours',
        method: 'POST',
        params
    })
}

export const reqClassHoursLog = (params) => {
    return request({
        url: pre+'/classHoursLog',
        method: 'GET',
        params
    })
}

export const reqGetStudentParents = (params) => {
    return request({
        url: pre+'/parents',
        method: 'GET',
        params
    })
}

export const reqGrantRole = (data) => {
    return request({
        url: pre+'/grantRole',
        method: 'POST',
        data: data
    })
}

// ==================== 教师专用接口 ====================

export const reqPageTeachers = (data) => {
    return request({
        url: pre+'/teacher/page',
        method: 'POST',
        data: data
    })
}

export const reqInsertTeacher = (data) => {
    return request({
        url: pre+'/teacher/insert',
        method: 'POST',
        data: data
    })
}

export const reqUpdateTeacher = (data) => {
    return request({
        url: pre+'/teacher/update',
        method: 'POST',
        data: data
    })
}

export const reqDeleteTeacher = (params) => {
    return request({
        url: pre+'/teacher/delete',
        method: 'get',
        params
    })
}

// ==================== 学生批量导入 ====================

/**
 * 批量导入学生（上传 Excel）
 * @param {FormData} formData 含 file 字段
 */
export const reqImportStudents = (formData) => {
    return request({
        url: pre + '/importStudents',
        method: 'POST',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}

/**
 * 下载学生导入模板
 */
export const reqStudentImportTemplate = () => {
    return request({
        url: pre + '/importTemplate',
        method: 'GET',
        responseType: 'blob'
    })
}
